import MESSAGES from 'core/data-model/constants/bi-messages'

import { get } from 'lodash/fp'

const getProductBenefitsConfig = () => {
  return require('core/service/data-config/product-benefit/benefit.json')
}

export const hasProductCodeInCategory = (basicPlanCode, productCategory, getConfig = getProductBenefitsConfig) => {
  return getConfig().productBenefit.some(
    (b) => b.productCategory === productCategory && b.productCodes && b.productCodes.includes(basicPlanCode)
  )
}

export const getBenefitData = (productCategory) => {
  // $FlowFixMe
  const productBenefit = getProductBenefitsConfig().productBenefit.find((data) => {
    return data.productCategory === productCategory
  })
  return get('benefitData')(productBenefit)
}

export const isLoanProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_LOAN)
}

export const isSavingProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_SAVING)
}

export const getLoanBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_LOAN)
}

export const isIProtectProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_WHOLE_LIFE)
}

export const getWholeLife25PLBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_WHOLE_LIFE_25PL)
}

export const isWholeLife25PLProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_WHOLE_LIFE_25PL)
}

export const isWholeLife12PLProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_WHOLE_LIFE_12PL)
}

export const getWholeLife12PLBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_WHOLE_LIFE_12PL)
}

export const isLifeProtectProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_WHOLE_LIFE_LIFEPROTECT)
}

export const isLifeReadyProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_WHOLE_LIFE_LIFEREADY)
}

export const getLifeProtectBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_WHOLE_LIFE_LIFEPROTECT)
}

export const isLifeEnsureProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_WHOLE_LIFE_LIFEENSURE)
}

export const isSukhapabDekDeeProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_SUKHAPABDEKDEE)
}

export const getLifeEnsureBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_WHOLE_LIFE_LIFEENSURE)
}

export const isIRetireProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_RETIREMENT)
}

export const getIRetireBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_RETIREMENT)
}

export const isLifeRetireProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_RETIREMENT_LR05)
}

export const getLifeRetireBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_RETIREMENT_LR05)
}

export const isProtectionProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_PROTECTION)
}

export const getIProtectBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_WHOLE_LIFE)
}

export const isIShieldProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_ISHIELD)
}
export const getIShieldBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_ISHIELD)
}

export const isIHealthyProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_HEALTH)
}

export const isFlexiHealthProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_FLEXI_HEALTH)
}

export const getHealthBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_HEALTH)
}

export const getFlexiHealthBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_FLEXI_HEALTH)
}

export const isLifeLegacyProduct = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_LIFE_LEGACY)
}

export const getLifeLegacyBenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_LIFE_LEGACY)
}

export const isLifeSavePro25P15Product = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_LIFE_SAVE_PRO_25P15)
}

export const isLifeSavePro20P10Product = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_LIFE_SAVE_PRO_20P10)
}

export const getLifeSavePro25P15BenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_LIFE_SAVE_PRO_25P15)
}

export const getLifeSavePro20P10BenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_LIFE_SAVE_PRO_20P10)
}

export const isS7Product = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_S7)
}

export const getS7BenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_S7)
}

export const getTermLife_GIO_LifeSuperSave_BenefitData = () => {
  return getBenefitData(MESSAGES.CATEGORY_TERM_LIFE_GIO)
}

export const isTermLife_GIO_Product = (basicPlanCode) => {
  return hasProductCodeInCategory(basicPlanCode, MESSAGES.CATEGORY_TERM_LIFE_GIO)
}
